module.exports = "tr td:last-child{vertical-align:middle}.appsvcConfigButton,.editButton{cursor:pointer}"